import Letterhead from "../Reusable/Letterhead2";
import MetaInfo from "../Reusable/MetaInfo2";
import SubjectLine from "../Reusable/SubjectLine2";
import Signature from "../Reusable/Signature2";


interface TerminationLetterProps {
  refNo: string;
  date: string;
  name: string;
  address: string;
  lastDate: string;
  designation: string;
  termination_reason: string;
  accessories: string;
}

const TerminationLetter = ({ refNo, date, name, address, lastDate, designation, termination_reason, accessories}: TerminationLetterProps) => (
  <div className="p-10  rounded-lg max-w-2xl mx-auto space-y-4">
    <Letterhead/>
    <hr className=" mx-auto w-4/4 border-t-2 border-black"/>
    <MetaInfo refNo={refNo} date={date} name={name} address={address} />
    <SubjectLine subject="Termination Letter" />

    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
    We deeply regret to inform you that your employment with us as <b>{designation}</b> terminates on <b>{lastDate}</b> with immediate effect. The reason for your termination is <b>{termination_reason}</b>.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
      Please complete all formalities for full and final settlement and surrender the companyproperties, 
      such as <b>{accessories}</b>.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
     We thank you for your service and wish you great success in the future.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
     If you require assistance, please contact the HR department.
    </p>

    <Signature />
  </div>
);

export default TerminationLetter;
